export const INITIAL_STATE = {}

export function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case "SUBSCRIPTION_DATA_ARRIVED/HELP_VIDEOS":
            return {...state, videos: action.payload.videos, failure: null}
        case "SUBSCRIPTION_DATA_FAILED/HELP_VIDEOS":
            return {...state, failure: action.payload}
        default:
            return state
    }
}

export default dispatch => ({})
